import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "salary-bonus-edit" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "grid-table" }
const _hoisted_4 = {
  key: 0,
  style: {"margin-top":"10px","display":"flex","flex-wrap":"wrap","gap":"5px","align-items":"center"}
}
const _hoisted_5 = {
  key: 1,
  style: {"margin-top":"10px","display":"flex","flex-wrap":"wrap","gap":"5px","align-items":"center"}
}
const _hoisted_6 = {
  key: 2,
  style: {"margin-top":"10px","display":"flex","flex-wrap":"wrap","gap":"5px","align-items":"center"}
}
const _hoisted_7 = {
  key: 3,
  style: {"margin-top":"10px","display":"flex","flex-wrap":"wrap","gap":"5px","align-items":"center"}
}
const _hoisted_8 = ["data-item-idx"]
const _hoisted_9 = {
  key: 1,
  class: "readonly-text"
}
const _hoisted_10 = ["data-item-idx"]
const _hoisted_11 = {
  key: 3,
  class: "readonly-text"
}
const _hoisted_12 = {
  key: 4,
  class: "readonly-text",
  style: {"background-color":"var(--el-fill-color-light)","color":"var(--el-text-color-regular)"}
}
const _hoisted_13 = {
  key: 5,
  class: "readonly-text"
}
const _hoisted_14 = ["data-item-idx"]
const _hoisted_15 = {
  key: 7,
  class: "readonly-text"
}
const _hoisted_16 = ["data-item-idx"]
const _hoisted_17 = {
  key: 9,
  class: "readonly-text"
}
const _hoisted_18 = ["data-item-idx"]
const _hoisted_19 = {
  key: 11,
  class: "readonly-text"
}
const _hoisted_20 = ["data-item-idx"]
const _hoisted_21 = {
  key: 13,
  class: "readonly-text"
}
const _hoisted_22 = ["data-item-idx"]
const _hoisted_23 = {
  key: 15,
  class: "readonly-text"
}
const _hoisted_24 = ["data-item-idx"]
const _hoisted_25 = {
  key: 17,
  class: "readonly-text"
}
const _hoisted_26 = ["data-item-idx"]
const _hoisted_27 = {
  key: 19,
  class: "readonly-text"
}
const _hoisted_28 = ["data-item-idx"]
const _hoisted_29 = {
  key: 21,
  class: "readonly-text"
}
const _hoisted_30 = ["data-item-idx"]
const _hoisted_31 = {
  key: 23,
  class: "readonly-text"
}
const _hoisted_32 = ["data-item-idx"]
const _hoisted_33 = {
  key: 25,
  class: "readonly-text"
}
const _hoisted_34 = ["data-item-idx"]
const _hoisted_35 = {
  key: 27,
  class: "readonly-text"
}
const _hoisted_36 = ["data-item-idx"]
const _hoisted_37 = {
  key: 29,
  class: "readonly-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", null, "ЗП + Премия (Год: " + _toDisplayString(_ctx.formData.academicYear) + ")", 1),
          _createElementVNode("div", null, [
            _createVNode(_component_el_button, { onClick: _ctx.goBack }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("Назад")
              ])),
              _: 1
            }, 8, ["onClick"]),
            (_ctx.formData.status !== 'APPROVED' && _ctx.hasAccess(_ctx.universityManagerRoles))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  onClick: _ctx.saveData,
                  loading: _ctx.saving
                }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode("Сохранить")
                  ])),
                  _: 1
                }, 8, ["onClick", "loading"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", {
          class: "table-container",
          onPaste: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handlePaste && _ctx.handlePaste(...args))),
          onKeydown: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleKeydown && _ctx.handleKeydown(...args)))
        }, [
          _createElementVNode("table", _hoisted_3, [
            _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "Наименование расходов"),
                _createElementVNode("th", null, "Кол-во единиц по штату"),
                _createElementVNode("th", null, "Кол-во единиц по факту"),
                _createElementVNode("th", null, "ВСЕГО"),
                _createElementVNode("th", null, "янв"),
                _createElementVNode("th", null, "фев"),
                _createElementVNode("th", null, "мар"),
                _createElementVNode("th", null, "апр"),
                _createElementVNode("th", null, "май"),
                _createElementVNode("th", null, "июн"),
                _createElementVNode("th", null, "июл"),
                _createElementVNode("th", null, "авг"),
                _createElementVNode("th", null, "сен"),
                _createElementVNode("th", null, "окт"),
                _createElementVNode("th", null, "ноя"),
                _createElementVNode("th", null, "дек")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.details, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.uuid || item.type + (item.eduArea ? item.eduArea.id : ''),
                  class: _normalizeClass({'group-row': _ctx.isGroup(item.type), 'calculated-row': _ctx.isCalculated(item.type) && item.type !== 'TEACHING_STAFF' && item.type !== 'BONUS_TEACHING_STAFF'})
                }, [
                  _createElementVNode("td", {
                    class: "title-cell",
                    style: _normalizeStyle(_ctx.getTitleStyle(item.type))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.getTitle(item)) + " ", 1),
                    (item.type === 'EXPENSES_JOB_PAYMENT' && _ctx.formData.status !== 'APPROVED' && _ctx.hasAccess(_ctx.universityManagerRoles))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.selectedSalaryItems,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedSalaryItems) = $event)),
                            multiple: "",
                            "collapse-tags": "",
                            placeholder: "Выберите виды расходов",
                            size: "small",
                            style: {"width":"250px"},
                            filterable: "",
                            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSalaryItemsChange($event, false)))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.standardSalaryItemsList, (cat) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: cat.type,
                                  label: cat.title,
                                  value: cat.type
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.type === 'BONUS' && _ctx.formData.status !== 'APPROVED' && _ctx.hasAccess(_ctx.universityManagerRoles))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.selectedBonusItems,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedBonusItems) = $event)),
                            multiple: "",
                            "collapse-tags": "",
                            placeholder: "Выберите виды расходов",
                            size: "small",
                            style: {"width":"250px"},
                            filterable: "",
                            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSalaryItemsChange($event, true)))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.standardBonusItemsList, (cat) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: cat.type,
                                  label: cat.title,
                                  value: cat.type
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.type === 'TEACHING_STAFF' && _ctx.formData.status !== 'APPROVED' && _ctx.hasAccess(_ctx.universityManagerRoles))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.selectedEduAreas,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedEduAreas) = $event)),
                            multiple: "",
                            "collapse-tags": "",
                            placeholder: "Выберите факультеты",
                            size: "small",
                            style: {"width":"250px"},
                            filterable: "",
                            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onEduAreasChange($event, false)))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allEduAreas, (cat) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: cat.id,
                                  label: cat.code === 'OTHER' ? cat.nameRu : (cat.code + ' - ' + cat.nameRu),
                                  value: cat.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.type === 'BONUS_TEACHING_STAFF' && _ctx.formData.status !== 'APPROVED' && _ctx.hasAccess(_ctx.universityManagerRoles))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.selectedBonusEduAreas,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedBonusEduAreas) = $event)),
                            multiple: "",
                            "collapse-tags": "",
                            placeholder: "Выберите факультеты",
                            size: "small",
                            style: {"width":"250px"},
                            filterable: "",
                            onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onEduAreasChange($event, true)))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allEduAreas, (cat) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: cat.id,
                                  label: cat.code === 'OTHER' ? cat.nameRu : (cat.code + ' - ' + cat.nameRu),
                                  value: cat.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 4),
                  (!_ctx.isGroup(item.type))
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 0,
                        "data-item-idx": index,
                        "data-col": "0"
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.staffCount,
                          "onUpdate:modelValue": ($event: any) => ((item.staffCount) = $event),
                          formatter: _ctx.formatInputNumber,
                          parser: _ctx.parseInputNumber,
                          onInput: _ctx.recalculate
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "parser", "onInput"])
                      ], 8, _hoisted_8))
                    : (_openBlock(), _createElementBlock("td", _hoisted_9, _toDisplayString(_ctx.formatInputNumber(item.staffCount) || '0'), 1)),
                  (!_ctx.isGroup(item.type))
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 2,
                        "data-item-idx": index,
                        "data-col": "1"
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.factCount,
                          "onUpdate:modelValue": ($event: any) => ((item.factCount) = $event),
                          formatter: _ctx.formatInputNumber,
                          parser: _ctx.parseInputNumber,
                          onInput: _ctx.recalculate
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "parser", "onInput"])
                      ], 8, _hoisted_10))
                    : (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString(_ctx.formatInputNumber(item.factCount) || '0'), 1)),
                  (!_ctx.isGroup(item.type))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(_ctx.formatNumber(item.total)), 1))
                    : (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString(_ctx.formatNumber(item.total)), 1)),
                  (!_ctx.isGroup(item.type))
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 6,
                        "data-item-idx": index,
                        "data-col": "3"
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.janSum,
                          "onUpdate:modelValue": ($event: any) => ((item.janSum) = $event),
                          formatter: _ctx.formatInputNumber,
                          parser: _ctx.parseInputNumber,
                          onInput: _ctx.recalculate
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "parser", "onInput"])
                      ], 8, _hoisted_14))
                    : (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(_ctx.formatNumber(item.janSum)), 1)),
                  (!_ctx.isGroup(item.type))
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 8,
                        "data-item-idx": index,
                        "data-col": "4"
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.febSum,
                          "onUpdate:modelValue": ($event: any) => ((item.febSum) = $event),
                          formatter: _ctx.formatInputNumber,
                          parser: _ctx.parseInputNumber,
                          onInput: _ctx.recalculate
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "parser", "onInput"])
                      ], 8, _hoisted_16))
                    : (_openBlock(), _createElementBlock("td", _hoisted_17, _toDisplayString(_ctx.formatNumber(item.febSum)), 1)),
                  (!_ctx.isGroup(item.type))
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 10,
                        "data-item-idx": index,
                        "data-col": "5"
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.marSum,
                          "onUpdate:modelValue": ($event: any) => ((item.marSum) = $event),
                          formatter: _ctx.formatInputNumber,
                          parser: _ctx.parseInputNumber,
                          onInput: _ctx.recalculate
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "parser", "onInput"])
                      ], 8, _hoisted_18))
                    : (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString(_ctx.formatNumber(item.marSum)), 1)),
                  (!_ctx.isGroup(item.type))
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 12,
                        "data-item-idx": index,
                        "data-col": "6"
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.aprSum,
                          "onUpdate:modelValue": ($event: any) => ((item.aprSum) = $event),
                          formatter: _ctx.formatInputNumber,
                          parser: _ctx.parseInputNumber,
                          onInput: _ctx.recalculate
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "parser", "onInput"])
                      ], 8, _hoisted_20))
                    : (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(_ctx.formatNumber(item.aprSum)), 1)),
                  (!_ctx.isGroup(item.type))
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 14,
                        "data-item-idx": index,
                        "data-col": "7"
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.maySum,
                          "onUpdate:modelValue": ($event: any) => ((item.maySum) = $event),
                          formatter: _ctx.formatInputNumber,
                          parser: _ctx.parseInputNumber,
                          onInput: _ctx.recalculate
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "parser", "onInput"])
                      ], 8, _hoisted_22))
                    : (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString(_ctx.formatNumber(item.maySum)), 1)),
                  (!_ctx.isGroup(item.type))
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 16,
                        "data-item-idx": index,
                        "data-col": "8"
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.junSum,
                          "onUpdate:modelValue": ($event: any) => ((item.junSum) = $event),
                          formatter: _ctx.formatInputNumber,
                          parser: _ctx.parseInputNumber,
                          onInput: _ctx.recalculate
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "parser", "onInput"])
                      ], 8, _hoisted_24))
                    : (_openBlock(), _createElementBlock("td", _hoisted_25, _toDisplayString(_ctx.formatNumber(item.junSum)), 1)),
                  (!_ctx.isGroup(item.type))
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 18,
                        "data-item-idx": index,
                        "data-col": "9"
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.julSum,
                          "onUpdate:modelValue": ($event: any) => ((item.julSum) = $event),
                          formatter: _ctx.formatInputNumber,
                          parser: _ctx.parseInputNumber,
                          onInput: _ctx.recalculate
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "parser", "onInput"])
                      ], 8, _hoisted_26))
                    : (_openBlock(), _createElementBlock("td", _hoisted_27, _toDisplayString(_ctx.formatNumber(item.julSum)), 1)),
                  (!_ctx.isGroup(item.type))
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 20,
                        "data-item-idx": index,
                        "data-col": "10"
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.augSum,
                          "onUpdate:modelValue": ($event: any) => ((item.augSum) = $event),
                          formatter: _ctx.formatInputNumber,
                          parser: _ctx.parseInputNumber,
                          onInput: _ctx.recalculate
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "parser", "onInput"])
                      ], 8, _hoisted_28))
                    : (_openBlock(), _createElementBlock("td", _hoisted_29, _toDisplayString(_ctx.formatNumber(item.augSum)), 1)),
                  (!_ctx.isGroup(item.type))
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 22,
                        "data-item-idx": index,
                        "data-col": "11"
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.sepSum,
                          "onUpdate:modelValue": ($event: any) => ((item.sepSum) = $event),
                          formatter: _ctx.formatInputNumber,
                          parser: _ctx.parseInputNumber,
                          onInput: _ctx.recalculate
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "parser", "onInput"])
                      ], 8, _hoisted_30))
                    : (_openBlock(), _createElementBlock("td", _hoisted_31, _toDisplayString(_ctx.formatNumber(item.sepSum)), 1)),
                  (!_ctx.isGroup(item.type))
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 24,
                        "data-item-idx": index,
                        "data-col": "12"
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.octSum,
                          "onUpdate:modelValue": ($event: any) => ((item.octSum) = $event),
                          formatter: _ctx.formatInputNumber,
                          parser: _ctx.parseInputNumber,
                          onInput: _ctx.recalculate
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "parser", "onInput"])
                      ], 8, _hoisted_32))
                    : (_openBlock(), _createElementBlock("td", _hoisted_33, _toDisplayString(_ctx.formatNumber(item.octSum)), 1)),
                  (!_ctx.isGroup(item.type))
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 26,
                        "data-item-idx": index,
                        "data-col": "13"
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.novSum,
                          "onUpdate:modelValue": ($event: any) => ((item.novSum) = $event),
                          formatter: _ctx.formatInputNumber,
                          parser: _ctx.parseInputNumber,
                          onInput: _ctx.recalculate
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "parser", "onInput"])
                      ], 8, _hoisted_34))
                    : (_openBlock(), _createElementBlock("td", _hoisted_35, _toDisplayString(_ctx.formatNumber(item.novSum)), 1)),
                  (!_ctx.isGroup(item.type))
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 28,
                        "data-item-idx": index,
                        "data-col": "14"
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.decSum,
                          "onUpdate:modelValue": ($event: any) => ((item.decSum) = $event),
                          formatter: _ctx.formatInputNumber,
                          parser: _ctx.parseInputNumber,
                          onInput: _ctx.recalculate
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "parser", "onInput"])
                      ], 8, _hoisted_36))
                    : (_openBlock(), _createElementBlock("td", _hoisted_37, _toDisplayString(_ctx.formatNumber(item.decSum)), 1))
                ], 2))
              }), 128))
            ])
          ])
        ], 32)
      ]),
      _: 1
    })
  ]))
}